import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LastDayToOrder from './LastDayReact';
import { isFuture, isToday } from 'date-fns';
import { parseUTC } from 'core/utils';

export const notInPast = (d) => {
	const orderBy = parseUTC(d);
	const stillHaveTime = isFuture(orderBy) || isToday(orderBy);
	if (! stillHaveTime) return;
	return true;
};

class LastDayContainer extends Component {
	render () {
		const { orderBy, arriveBy, arriveByName } = this.props;
		return (notInPast(orderBy) && (arriveBy || arriveByName)) ? (
			<LastDayToOrder orderBy={orderBy} arriveBy={arriveBy} arriveByName={arriveByName} />
		) : null;
	}

	static propTypes = {
		orderBy: PropTypes.string,
		arriveBy: PropTypes.string,
		arriveByName: PropTypes.string,
	}

	static defaultProps = {}
}

export default LastDayContainer;
